export const DIARY_GENERAL_ROUTE = 'agenda',
  NEWS_GENERAL_ROUTE = 'noticias',
  CAREER_GENERAL_ROUTE = 'carreras'
